function url(version: 'v1' | 'v2') {
  return (path: string) => `/${version}/admin${path}`;
}

const v1 = url('v1');

const API = {
  V1: {
    get login() {
      return v1('/auth/login');
    },
    get logout() {
      return v1('/auth/logout');
    },
    get profile() {
      return v1('/profile');
    },
    get users() {
      return v1('/users');
    },
    get usersSummary() {
      return v1('/users/summary');
    },
    get usersExport() {
      return v1('/users/export');
    },
    user: (id: string) => v1(`/user/${id}`),
    userDelete: (id: string) => v1(`/user/${id}/delete`),
    userDeleteCancel: (id: string) => v1(`/user/${id}/delete/cancel`),
    userSendVerificationEmail: (id: string) => v1(`/user/${id}/email/send-verification`),
    userSuspend: (id: string) => v1(`/user/${id}/suspend`),
    userReactivate: (id: string) => v1(`/user/${id}/reactivate`),
    userApprove: (id: string) => v1(`/user/${id}/approve`),
    userSessions: (id: string) => v1(`/user/${id}/session`),
    userSessionsRevokeAll: (id: string) => v1(`/user/${id}/session/revoke`),
    userSessionRevoke: (id: string, deviceId: string) =>
      v1(`/user/${id}/session/${deviceId}/revoke`),
    userStatements: (id: string) => v1(`/user/${id}/statement`),
    get transfers() {
      return v1('/transfer');
    },
    get transfersSummary() {
      return v1('/transfer/summary');
    },
    get balance() {
      return v1('/balance');
    },
    get transfersExport() {
      return v1('/transfer/export');
    },
    transfer: (id: string) => v1(`/transfer/${id}`),
    transferRemark: (id: string) => v1(`/transfer/${id}/remark`),
    get settlements() {
      return v1('/settlement');
    },
    get settlementsStatistic() {
      return v1('/settlement/statistic');
    },
    settlement: (id: string) => v1(`/settlement/${id}`),
    get withdrawals() {
      return v1('/batch-withdrawal');
    },
    get withdrawalsStatistic() {
      return v1('/batch-withdrawal/statistic');
    },
    get withdrawalsExport() {
      return v1('/batch-withdrawal/export');
    },
    withdrawal: (id: string) => v1(`/batch-withdrawal/${id}`),
    get unwithdrawn() {
      return v1('/batch-withdrawal/unwithdrawn');
    },
    get customerReports() {
      return v1('/customer-reports');
    },
    get customerReportsSummary() {
      return v1('/customer-reports/summary');
    },
    get customerReportReasons() {
      return v1('/customer-reports/reasons');
    },
    customerReport: (id: string) => v1(`/customer-reports/${id}`),
    get customerReportsExport() {
      return v1('/customer-reports/export');
    },
    get kycSubmissions() {
      return v1('/kyc/submissions');
    },
    kycApprove: (id: string) => v1(`/kyc/${id}/approve`),
    kycReject: (id: string) => v1(`/kyc/${id}/reject`),
    kycSubmissionDetail: (id: string) => v1(`/kyc/submissions/${id}`),
    kycSubmissionKtp: (id: string) => v1(`/kyc/submissions/${id}/ktp`),
    kycSubmissionSelfie: (id: string) => v1(`/kyc/submissions/${id}/selfie`),
    kycSubmissionAccessHistory: (id: string) => v1(`/kyc/submissions/${id}/access-history`),
    get manualTransfers() {
      return v1('/manual-transfers');
    },
    get manualTransfersSummary() {
      return v1('/manual-transfers/summary');
    },
    get manualTransfersExport() {
      return v1('/manual-transfers/export');
    },
    get manualTransfersEvidenceUploadUrl() {
      return v1('/manual-transfers/evidence-upload-url');
    },
    manualTransfer: (id: string) => v1(`/manual-transfers/${id}`),
    manualTransferClaim: (id: string) => v1(`/manual-transfers/${id}/claim`),
    manualTransferProposal: (id: string) => v1(`/manual-transfers/${id}/proposal`),
    manualTransferDecision: (id: string) => v1(`/manual-transfers/${id}/decision`),
    manualTransferHold: (id: string) => v1(`/manual-transfers/${id}/hold`),
    manualTransferReleaseHold: (id: string) => v1(`/manual-transfers/${id}/release-hold`),
    manualTransferNotes: (id: string) => v1(`/manual-transfers/${id}/notes`),
  },

  V2: {},
};

export default API;
